import * as React from 'react';
import { H3 } from '~ui/components/typography/Heading/Heading';
import { getHeaderFontSizeInPx } from '~ui/styleGuide/fontStyles';
import { LAYOUT_BREAKPOINTS } from '../../Responsive/client';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultTextAlign = "center";
/**
 * Styled heading (H3) to sync it between the validation messages.
 */

export var ValidationMessageHeading = function ValidationMessageHeading(_ref) {
  var children = _ref.children,
      textAlign = _ref.textAlign;
  return /*#__PURE__*/_jsx(H3, {
    fontStyle: "boldSemi",
    textAlign: textAlign !== null && textAlign !== void 0 ? textAlign : defaultTextAlign,
    responsiveSize: {
      minSize: getHeaderFontSizeInPx("l24"),
      maxSize: getHeaderFontSizeInPx("l28"),
      minBreakpoint: LAYOUT_BREAKPOINTS.smMin,
      maxBreakpoint: LAYOUT_BREAKPOINTS.mdMax
    },
    children: children
  });
};